import { compose, withProps, lifecycle } from 'recompose'
import { connect } from 'react-redux'

import IndexPage from '../components/Home'
import { withInitialData } from '../components/hoc'
import { getScrollingBanner } from '../reducers/admin'


const mapDispatchToProps = dispatch => ({
  getScrollingBanner: () => dispatch(getScrollingBanner())
})

const mapStateToProps = state => ({
  scrollingBanner: state.admin.scrollingBanner
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps({
    contentImage: ''
  }),
  withInitialData,
  lifecycle({
    componentDidMount () {
      this.props.getScrollingBanner()
    }
  })
)(IndexPage)




// WEBPACK FOOTER //
// ./pages/index.js